// This is the default config used in every environment.
// Any key can be overwritten with the spread operator.
import packageJson from "../../package.json";

export const environment = {
  version: packageJson.version,
  production: false,
  useLocalTranslation: false,
  useMockService: false,
  asfSvgCacheUrl: 'https://maps.asfinag.at/cache/svg?image=', // e.g. + 'vks_icon_baustelle&size=40
  enableMatomoTracking: false,
  matomoJsSource: 'https://analytics-test.asfinag.at/matomo.js',
  matomoTrackingUrl: 'https://analytics-test.asfinag.at/',
  matomoSiteId: '26',
  urls: {
    translations: '',
  },
  apiRoot: 'https://localhost:44420',
  allowedDomain: 'localhost:44420',
};
